var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { detect } from '@pacem/pacem-foundation';
import { CustomElement, Watch } from '../../decorators';
import { P } from '../../prefix';
import { PropertyConverters } from '../../converters';
import { PropertyChangeEvent } from '../../events';
import { PacemEventTarget } from '../../eventtarget';
//namespace Pacem.Components {
let PacemBrowserDetectElement = class PacemBrowserDetectElement extends PacemEventTarget {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._detect();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'userAgent') {
            this._detect(val);
        }
    }
    #browser;
    #version;
    get browser() {
        return this.#browser;
    }
    get version() {
        return this.#version;
    }
    _detect(userAgent = this.userAgent) {
        const { version, name } = detect(userAgent);
        const { browser: oldName, version: oldVersion } = this;
        if (name != oldName) {
            this.#browser = name;
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'browser', currentValue: name, oldValue: oldName }));
        }
        if (version != oldVersion) {
            this.#version = version;
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'version', currentValue: version, oldValue: oldVersion }));
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBrowserDetectElement.prototype, "userAgent", void 0);
PacemBrowserDetectElement = __decorate([
    CustomElement({ tagName: P + '-browser-detect' })
], PacemBrowserDetectElement);
export { PacemBrowserDetectElement };
//}
